<template>
  <div>
    <div class="rounded primary white--text py-6 d-flex flex-column align-center">
      <v-icon size="96px" color="white">mdi-check-circle-outline</v-icon> 
      <div class="mt-3 font-weight-bold" style="font-size: 24px;">Payment Successful!</div>
    </div>

    <div class="black--text px-5 py-6">
      <div>
        Thank you for updating your membership. Please allow a few minutes for your
        payment to post to your account. Your membership will automatically update once
        the system has refreshed.
      </div> 
      <div class="mt-6">
        Thanks again,<br>
        The PartnerLists Team
      </div>
      <div class="d-flex justify-center mt-8">
        <v-btn color="primary" :to="{ name: 'billing/account' }">Continue</v-btn>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BillingReactivateConfirmView',
}
</script>